<div class="text-component" style="width: 100%; height: 100%">
  @if (hasInput('content')) {
  <div [innerHTML]="processedContent"></div>
  }
</div>
